import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default {
  props: {
    src: String
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: "glass-view",
        style: _normalizeStyle({
          '--backgroundImg': "url(".concat(__props.src, ")")
        })
      }, null, 4);
    };
  }
};